(() => {
  const selector = 'button,input[type="submit"],input[type="button"],input[type="reset"],[role="button"],a[class*="button"],a[class*="btn"],.ccr-card-copy > a,.cil-explorer-links > a,.csr__scroll';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Map();
  const animations = new WeakMap();
  const motionTarget = (button) => button.querySelector(':scope > .cil-card-media') || button;
  const eligible = (button) => button && !button.matches(':disabled,[aria-disabled="true"],.disabled');
  const decorate = (root) => {
    const buttons = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) buttons.unshift(root);
    buttons.forEach((button) => {
      if (button.classList.contains('casidor-button-motion')) return;
      const position = getComputedStyle(button).position;
      button.classList.add('casidor-button-motion');
      if (position === 'static') button.classList.add('casidor-button-motion--relative');
      if (button.matches('a[class*="button"],a[class*="btn"],.m-button,.ccr-card-copy > a,[data-ccr-facts],.cil-supplement-button,.cil-explorer-links > a') && !['absolute','fixed'].includes(position)) button.classList.add('casidor-button-motion--cta');
      if (button.tagName !== 'INPUT') {
        [...button.children].forEach((child) => {
          if (child.tagName === 'SPAN' && child.textContent.trim() === '→') child.classList.add('casidor-button-arrow');
        });
        const sheen = document.createElement('span');
        sheen.className = 'casidor-button-sheen';
        sheen.setAttribute('aria-hidden', 'true');
        motionTarget(button).append(sheen);
      }
    });
  };
  decorate(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && !node.classList.contains('casidor-button-sheen')) decorate(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' || reduced.matches) return;
    const button = event.target.closest('.casidor-button-motion');
    if (!eligible(button)) return;
    animations.get(button)?.cancel();
    button.classList.add('cbm-pressed');
    active.set(event.pointerId, { button, x: event.clientX, y: event.clientY });
  }, { passive: true });
  const release = (event, rebound) => {
    const press = active.get(event.pointerId);
    if (!press) return;
    active.delete(event.pointerId);
    press.button.classList.remove('cbm-pressed');
    if (!rebound || reduced.matches || !eligible(press.button) || !press.button.isConnected) return;
    animations.set(press.button, motionTarget(press.button).animate([
      { scale: '.96', offset: 0 },
      { scale: '1.035', offset: .58 },
      { scale: '1', offset: 1 }
    ], { duration: 280, easing: 'cubic-bezier(.2,.7,.3,1)' }));
  };
  document.addEventListener('pointerup', (event) => release(event, true), { passive: true });
  document.addEventListener('pointercancel', (event) => release(event, false), { passive: true });
  document.addEventListener('pointermove', (event) => {
    const press = active.get(event.pointerId);
    if (press && Math.hypot(event.clientX - press.x, event.clientY - press.y) > 12) release(event, false);
  }, { passive: true });
  window.addEventListener('blur', () => {
    active.forEach(({ button }) => button.classList.remove('cbm-pressed'));
    active.clear();
  });
})();
